// extracted by mini-css-extract-plugin
export var columnList = "_eb-0";